import { combineReducers } from "redux";

// Reducers
import settings from "../settings/reducer";
import config from "../config/reducer";
import device from "../device/reducer";
import auth from "../auth/reducer";
import intl from "../intl/reducer";
import users from "../users/reducer";
import menu from "../menu/reducer";
import fields from "../fields/reducer";
import pages from "../pages/reducer";
import pageTranslations from "../pageTranslations/reducer";
import templates from "../templates/reducer";
import categories from "../categories/reducer";
import categoriesTranslations from "../categoriesTranslations/reducer";
import fieldCategories from "../fieldCategories/reducer";
import fieldCategoriesTranslations
  from "../fieldCategoriesTranslations/reducer";
import audits from "../audits/reducer";
import locales from "../locales/reducer";
import medias from "../media/reducer";
import mediaCategories from "../mediaCategories/reducer";
import menus from "../menus/reducer";
import menuItems from "../menuItems/reducer";
import menusTranslations from "../menuTranslations/reducer";
import notifications from "../notifications/reducer";
import pagesLists from "../pagesLists/reducer";
import settingsApi from "../settingsApi/reducer";
import userGroups from "../userGroups/reducer";
import sections from "../sections/reducer";
import galleries from "../galleries/reducer";
import galleryItems from "../galleryItems/reducer";
import orders from "../orders/reducer";
import formSubmissions from "../formSubmissions/reducer";

const appReducer = combineReducers({
  settings,
  device,
  config,
  auth,
  intl,
  users,
  menu,
  fields,
  pages,
  pageTranslations,
  templates,
  categories,
  categoriesTranslations,
  fieldCategories,
  fieldCategoriesTranslations,
  audits,
  locales,
  medias,
  mediaCategories,
  menus,
  menuItems,
  menusTranslations,
  notifications,
  pagesLists,
  settingsApi,
  userGroups,
  sections,
  galleries,
  galleryItems,
  orders,
  formSubmissions
});

export default appReducer;



// WEBPACK FOOTER //
// ./src/common/app/reducer.js